export default {
    client:{
                sandbox:'AYfSXMp0Km_oHKtWJhgsK5hMN5ewl-scvkQ-5c7J56e3e-p6ouqpDZ6A90YoGJTJAw2HrzsLQPf-OeLV',
                production: 'AYw0qMIqebj-FFLMgpoySkNPwlAB13K3tB2LpFdmHefbVRiHuGnyDMAIXcU24y2yb1kfjhh8RpH5FjU6'
            },
    env:"sandbox"
}